import { useMutation } from '@tanstack/react-query';
import { useUserState } from '../../hooks/context/useUserState';
import { UserLoginContentBody } from '../types/generated/login_post.content';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { requestLogin } from '../requests/requestLogin';
import { useMenu } from './useMenu';
import { useApp } from './useApp';
import { LOG_IN } from '../../constants';

type LoginArgs = {
  body: UserLoginContentBody;
  keepLoggedIn: boolean;
};

export const useLogin = () => {
  const {
    state: { token, menuId },
    dispatch,
  } = useUserState();
  const { getMenu } = useMenu();
  const { getApp } = useApp();
  const handleApiError = useApiErrorHandling();
  const {
    isPending,
    error,
    mutate: login,
  } = useMutation({
    mutationFn: ({ body }: LoginArgs) => requestLogin(body, token),
    onSuccess: async (
      {
        userName,
        // userLanguage,
        sessionToken,
        venueName,
      },
      variables
    ) => {
      const newToken = sessionToken ? sessionToken : token;
      if (newToken) {
        if (menuId) {
          await getMenu({
            sessionToken: newToken,
            menuId,
          });
        }

        dispatch({
          type: LOG_IN,
          username: userName || variables.body.userLogin,
          userLogin: variables.body.userLogin,
          sessionToken: newToken,
          keepLoggedIn: variables.keepLoggedIn,
          venueName,
        });

        getApp({ sessionToken: newToken }).catch((e) => handleApiError(e));
      }
      //TODO: Enable when SQL will support multiple languages
      // if (userLanguage) {
      //   setLanguage({
      //     language: userLanguage,
      //     sessionToken,
      //     loggedIn: true,
      //   });
      // }
    },
    onError: (e) => {
      handleApiError(e);
    },
  });
  return {
    isPending,
    error,
    login,
  };
};
